import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import baterai from '../images/seagull-baterai.jpg';
import airbagg from '../images/seagull-airbag.jpg';
import kaki from '../images/seagull-kaki.jpg';
import rangka from '../images/seagull-rangka.jpg';
import charging from '../images/seagull-charging.jpg';
import fitur from '../images/seagull-fitur.jpg';

function FiturSeagull() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>
          Fitur BYD Atto 1 NIK 2026 | Keamanan, Baterai & Charging
        </title>
        <meta
          name='description'
          content='Pelajari fitur BYD Atto 1 NIK 2026: 4 airbag, Blade Battery, pengisian DC, NFC dan Bluetooth key, kursi elektrik, serta perbedaan Dynamic dan Premium.'
        />
        <meta
          name='keywords'
          content='fitur BYD Atto 1 NIK 2026, keamanan BYD Atto 1, Blade Battery Atto 1, charging BYD Atto 1, BYD BSD Serpong'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/fitur-byd-atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        Fitur dan Teknologi BYD Atto 1 NIK 2026
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        BYD Atto 1 NIK 2026 dilengkapi fitur keselamatan, Blade Battery,
        pengisian AC dan DC, konektivitas smartphone, serta kunci NFC dan
        Bluetooth. Artikel ini merangkum fitur utama dan penyesuaian yang perlu
        diperhatikan sebelum memilih Dynamic atau Premium.
      </Typography>

      {/* Airbag Section */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          4 Airbag dan Sistem Keselamatan
        </Typography>
        <img
          src={airbagg}
          alt='Airbag BYD Atto 1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          BYD Atto 1 Dynamic dan Premium NIK 2026 menggunakan 4 airbag. Sistem
          keselamatan lainnya mencakup ABS, EBD, ESC, TPMS, ISOFIX, dan fitur
          pengereman yang mendukung penggunaan harian.
        </Typography>
      </Box>

      {/* Blade Battery */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Blade Battery dengan Kimia LFP
        </Typography>
        <img
          src={baterai}
          alt='Baterai Blade BYD Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          BYD Atto 1 menggunakan Blade Battery berbasis LFP. Dynamic memakai
          kapasitas 30,08 kWh dengan jarak tempuh hingga 300 km NEDC, sedangkan
          Premium memakai 38,88 kWh dengan jarak tempuh hingga 380 km NEDC.
        </Typography>
      </Box>

      {/* Fast Charging */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Pengisian DC 30-80% Sekitar 30 Menit
        </Typography>
        <img
          src={charging}
          alt='Charging Atto1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Pengisian DC dari 30% ke 80% membutuhkan waktu sekitar 30 menit dalam
          kondisi yang sesuai. Dynamic mendukung DC hingga 30 kW, sedangkan
          Premium hingga 40 kW. Waktu aktual dipengaruhi kondisi baterai,
          temperatur, dan kemampuan charger.
        </Typography>
      </Box>

      {/* Suspensi dan Kaki-kaki */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Kaki-kaki Stabil dan Empuk untuk Kenyamanan Kota
        </Typography>
        <img
          src={kaki}
          alt='Kaki-kaki BYD Atto 1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Suspensi MacPherson di bagian depan dan torsion beam di belakang
          membantu BYD Atto 1 tetap stabil dan mudah dikendalikan untuk
          penggunaan di jalan perkotaan.
        </Typography>
      </Box>

      {/* Rangka Baja */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Rangka Baja Ultra High-Strength: Tangguh & Ringan
        </Typography>
        <img
          src={rangka}
          alt='Rangka BYD Atto 1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Atto 1 menggunakan rangka baja berkekuatan tinggi (ultra
          high-strength steel) untuk menjaga keseimbangan antara ringan dan
          kuat. Ini membuat konsumsi energi lebih efisien sekaligus memperkuat
          daya tahan struktur terhadap benturan.
        </Typography>
      </Box>

      {/* Fitur Pintar NFC */}
      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Buka Mobil Pakai Smartphone? Bisa Banget!
        </Typography>
        <img
          src={fitur}
          alt='Fitur NFC BYD Atto 1'
          style={{ width: '100%', marginBottom: 16 }}
        />
        <Typography variant='body1' paragraph>
          Kunci digital NFC dan Bluetooth membantu akses kendaraan menjadi lebih
          praktis. Ketersediaan dan kompatibilitas perangkat perlu dikonfirmasi
          saat serah terima unit.
        </Typography>
      </Box>

      {/* Kesimpulan dan CTA */}
      <Paper
        sx={{
          p: 4,
          mt: 6,
          backgroundColor: '#e3f2fd',
          borderLeft: '6px solid #1976d2',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          🚗 Siap Punya Mobil Listrik Seaman & Secanggih Ini?
        </Typography>
        <Typography variant='body1'>
          Semua fitur ini bisa kamu dapatkan langsung di{' '}
          <strong>BYD BSD Serpong</strong>. Dapatkan juga info lengkap seputar{' '}
          <strong>Harga Denza D9</strong>, <strong>Harga Sealion 7</strong>, dan{' '}
          <strong>Harga Atto 1</strong> dengan menghubungi tim kami.
        </Typography>
        <Typography variant='body2' sx={{ mt: 1 }}>
          📞{' '}
          <a
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20fitur%20BYD%20Atto%201%20NIK%202026'
            target='_blank'
            rel='noopener noreferrer'
          >
            Chat WhatsApp
          </a>{' '}
          atau kunjungi Instagram kami di{' '}
          <a
            href='https://instagram.com/bydbsdserpong'
            target='_blank'
            rel='noopener noreferrer'
          >
            @bydbsdserpong
          </a>
          !
        </Typography>
      </Paper>
    </Box>
  );
}

export default FiturSeagull;
